import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router } from '@angular/router';
import { ROUTE_PATHS } from '@constants/routes';

export const optOutRedirectGuard: CanActivateFn = (route: ActivatedRouteSnapshot): boolean => {
  const router = inject(Router);
  const queryParams = route.queryParams;
  router.navigate([ROUTE_PATHS.IMPORTED_OPT_OUT], { queryParams });
  return false;
};
